<template>
  <Card
    v-bind="$attrs"
    clickable
    :morph="appointment.timeline_morph"
    :pinned="appointment.timeline_pinned"
    :simple="simple"
    @click="viewingAppointmentID = appointment.id"
  >
    <span
      class="absolute-top-right triangle"
      :style="{'color': fieldColor}"
    />

    <q-item-section>
      <div class="flex justify-between no-wrap-sm">
        <div style="flex: 1 0 150px;">
          <div class="text-caption text-bold q-mb-xs">
            Appointment
          </div>

          <q-item-label v-if="appointment.title">
            <span class="module-name">
              {{ appointment.title }}
            </span>

            <template v-if="appointment.types">
              <q-chip
                v-for="(typeName, key) in appointment.types"
                :key="key"
                :title="typeName"
                dense
                square
                color="grey-3"
                size="10px"
                class="q-my-none q-mx-xs"
              >
                {{ truncateString(typeName, 35) }}
              </q-chip>
            </template>
          </q-item-label>
        </div>

        <div style="flex: 0 1 175px;" class="q-py-xs">
          <q-item-label caption>
            <DateTimePartial
              :is-scheduled="appointment.status !== 'UNSCHEDULED'"
              :all-day="appointment.all_day"
              :start-date="appointment.start_date"
              :end-date="appointment.end_date"
              :timezone="appointment.timezone"
              without-length
            />
          </q-item-label>
        </div>
      </div>

      <q-item-label
        v-if="appointment.address"
        caption
        class="text-bold"
      >
        {{ appointment.address }}
      </q-item-label>

      <q-item-label
        v-if="appointment.description"
        caption
      >
        <nl2br
          tag="div"
          :text="appointment.description"
        />
      </q-item-label>
    </q-item-section>
  </Card>

  <AppointmentDialog
    :id="viewingAppointmentID"
    without-client
    allow-editing
    allow-deleting
    @deleted="$emit('remove')"
    @close="viewingAppointmentID = null"
  />
</template>

<script>
import { defineAsyncComponent } from 'vue'

import DateTimePartial from 'components/app/calendar/partials/DateTime'
import Card from 'components/partials/timeline/partials/Card'
import statusMixin from 'components/app/calendar/partials/mixins/statusMixin'
import cardMixin from 'components/partials/timeline/partials/cardMixin'

export default {
  components: {
    Card,
    DateTimePartial,
    AppointmentDialog: defineAsyncComponent(() => import('src/components/app/calendar/partials/view/Dialog'))
  },
  mixins: [statusMixin, cardMixin],
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  emits: ['remove'],
  data () {
    return {
      viewingAppointmentID: null
    }
  },
  computed: {
    fieldColor () {
      return this.baseFieldColor(this.appointment.status)
    }
  }
}
</script>
